import { NgModule } from '@angular/core'
import { FloSanitizeResourceUrlPipe } from './sanitize-resource-url.pipe'

@NgModule({
  declarations: [FloSanitizeResourceUrlPipe],
  exports: [FloSanitizeResourceUrlPipe]
})
export class FloSanitizeResourceUrlModule {}
